export const DUPLICATE_MODULE = 'DUPLICATE_MODULE';
export const DUPLICATE_MODULE_FAILURE = 'DUPLICATE_MODULE_FAILURE';
